import { render, staticRenderFns } from "./DetalleInscripcion.vue?vue&type=template&id=593970a0&"
import script from "./DetalleInscripcion.vue?vue&type=script&lang=js&"
export * from "./DetalleInscripcion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports